import {useTranslation} from 'next-i18next'
import {Box, Text} from '@chakra-ui/react'
import BreakpointsHelper from 'helpers/BreakpointsHelper/BreakpointsHelper'

export const EmptyCartInfo = () => {
    const {t} = useTranslation('cart')
    return (
        <Box sx={{minHeight: '120px', display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: '5px' }}>
            <Text
                my={{
                    base: 4,
                    lg: 6,
                }}
                ml={{
                    base: 4
                }}
                sx={{
                    fontWeight: '600'
                }}
            >
                {t('EMPTY_CART')}
            </Text>
            <br/>
            <Text
                my={{
                    base: 4,
                    lg: 6,
                }}
                ml={{
                    base: 4
                }}
            >
                Dołącz do grona miłośników doskonałego stylu i wypełnij go produktami Lilou.
            </Text>
        </Box>
    )
}
